//请自行添加语言资源
const sku = {
  skuCode:'sku编码',
  skuNameZh: 'sku中文名称',
  skuNameEn: 'sku英文名称',
  skuDesc:'sku描述',
  skuType:'sku类型',
  length:'长',
  width:'宽',
  height:'高',
  volume: '体积',
  netWeight:'净重',
  grossWeight:'毛重',
  createTime:'创建时间',
  creator:'创建者',
  updateTime:'更新时间',
  updater:'更新者',
  msg:{
    recycleBoxNo: '请输入周转箱号起始数字',
    recycleBoxNoBegin: '请输入周转箱号结束数字',
    recycleBoxNoEnd: '请输入周转箱号',
    warehouseCode: '请选择仓库'
  }
};
export default sku



// WEBPACK FOOTER //
// ./src/page/md/sku/lang/sku.zh.js